import React, { Component } from 'react';
import { Button, Icon, Header, Segment, Image } from 'semantic-ui-react';
import { connect } from 'react-redux';
import 'react-intl-tel-input/dist/main.css';
import { withTranslation } from 'react-i18next';
import Page from '../../../components/Page';
import { Link } from 'react-router-dom';
class PlatformModal extends Component {
	state = {
		selectedPlatform: '',
		activePage: 1,
		btnLoading: false,
	};

	render() {
		let { t } = this.props;

		return (
			<Page.Wrap>
				<Segment>
					<div>
						<Button basic color="grey" labelPosition="left" icon size="small" as={Link} to="/appstore/help">
							<Icon name="arrow left"></Icon>
							{t('back')}
						</Button>
						<Header>{'WhatsApp Business'}</Header>
					</div>

					<div className="help">
						<p>
							Chrome eklentimizin etiket özelliğini kullanabilmeniz için, WhatsApp Web'e okutulacak olan numaranın WhatsApp Business uygulamasına
							bağlı olması gerekmektedir.
						</p>
						<p>
							Çoklu agent sisteminide kullanabilmeniz için WhatsApp Business'ın beta sürümüne geçiş yapıp, WhatsApp çoklu cihaz desteğini
							açmalısınız. Resimde nasıl açıldığını görebilirsiniz.
							<Image src="/images/waba.png" style={{ width: '900px' }}></Image>
						</p>
						<p>
							Chrome tarayıcınızdan{' '}
							<a href="https://web.whatsapp.com" target="_blank" rel="noopener noreferrer">
								https://web.whatsapp.com
							</a>{' '}
							adresine gidip QR okutarak kullanmaya başlayabilirsiniz. Diğer agentların oturumlarında okutmak için Anydesk, Teamviewer gibi
							uzaktan kontrol programlarını kullanıp uzaktaki bilgisayar için QR okutabilirsiniz.
						</p>
					</div>
				</Segment>
			</Page.Wrap>
		);
	}
}
const stateToProps = (state) => ({ user: state.access.user.loggedUserObj, product: state.product.live });

export default connect(stateToProps)(withTranslation()(PlatformModal));
